module.exports = __webpack_public_path__ + "img/83.4a8e53f.png";